/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToolsService } from 'src/app/services/tools.service';
import { MinimizeIconComponent } from 'src/chatbot/icons/minimize-icon.component';
import { FullScreenIconComponent } from 'src/chatbot/icons/full-screen-icon.component';
import { NormalScreenIconComponent } from 'src/chatbot/icons/normal-screen-icon.component';
import { DataChatService } from 'src/chatbot/service/dataChat.service';
import { ModalController } from '@ionic/angular';
import { ChatBotInfoComponent } from '../chatBotInfo/chatBotInfo.component';
import { SendMailComponent } from '../sendMail/sendMail.component';
import { ReloadIconComponent } from 'src/chatbot/icons/reload-icon.component';
import { WebSocketService } from 'src/chatbot/service/webSocket.service';
import { StatisticsService } from 'src/app/services/statistics.service';

@Component({
  selector: 'chat-header',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MinimizeIconComponent,
    FullScreenIconComponent,
    NormalScreenIconComponent,
    ReloadIconComponent,
  ],
  templateUrl: './chatHeader.component.html',
  styleUrl: './chatHeader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatHeaderComponent {
    private statisticsService = inject(StatisticsService)
    private webSocketService = inject(WebSocketService)
    public toolsService = inject(ToolsService)
    public dataChatService = inject(DataChatService);
    public logoSrc = computed(() => this.dataChatService.icon())
    public chatName = computed(() => this.dataChatService.name())
    public isFullScreen = computed(() => this.dataChatService.isFullScreen())
    public hasSaveChat = computed(() => this.dataChatService.hasSaveChat())
    public canSaveChat = computed(() => this.dataChatService.canSaveChat())
    public isNew = computed(() => this.dataChatService.isNew());

    private modalController = inject(ModalController)
    private modal: any;

    toggleView(){
        this.dataChatService.hideChat.update(prev => !prev);
        if (this.dataChatService.hideChat()) 
          this.dataChatService.isFullScreen.set(false)
    }

    resetChat(){
      this.webSocketService.disconnect();
      this.webSocketService.historyChat = [];
      const newToken = this.statisticsService.generateNewSessionId();
      this.dataChatService.token.set(newToken);
      this.dataChatService.messages.set([])
      this.dataChatService.requestIsFulliled.set(false);
      this.webSocketService.connectAll();
        // this.dataChatService.resetChat();
    }

    toggleFullScreen(){
      this.dataChatService.isFullScreen.update(prev => !prev);
    }

    toggleAction(action){
      switch(action){
        case 'email': 
          if (!this.canSaveChat()) return;
          this.openModal(SendMailComponent); 
          break;
        case 'info': this.openModal(ChatBotInfoComponent); break;
      }
    }

    async openModal(component) {
      if (this.modal) return;
      this.modal = await this.modalController.create({
        component: component,
        cssClass: ['chatBotModal', 'ion-disable-focus-trap'],
        componentProps: {},
      });
      await this.modal.present();
      await this.modal.onDidDismiss();
      this.modal = null;
    }


}